import { render, staticRenderFns } from "./FoldersHierarchy.vue?vue&type=template&id=557b00a4&"
import script from "./FoldersHierarchy.vue?vue&type=script&lang=js&"
export * from "./FoldersHierarchy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports